export default function HeroSection() {
  return (
    <section id="home" className="relative min-h-[420px] md:min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 animate-hero-zoom">
        <img
          alt="Luxury Travel Experience with Lucky Holidays"
          title="Lucky Holidays - Premium Luxury Travel"
          className="w-full h-full object-cover object-top"
          src="https://storage.helloreaddy.io/project_files/aa0c5db7-25bc-4b3b-90ec-7347042fd498/160ab5a2-33f2-4fac-a5a1-ac97366ec144_compressed_Gemini_Generated_Image_qmtuxbqmtuxbqmtu-1.webp"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 py-16 md:py-32 3xl:max-w-[1800px] 3xl:mx-auto tv:max-w-[3000px] tv:mx-auto">
        <div className="max-w-3xl tv:max-w-4xl">

          {/* Badge */}
          <div className="animate-fade-in-up animate-fade-in-up-delay-2">
            <span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-foreground-950/25 backdrop-blur-md text-background-50 text-[10px] md:text-sm font-medium tracking-widest uppercase rounded-full border border-background-50/25 mb-4 md:mb-6">
              Premium Travel &amp; Tourism
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-heading text-2xl sm:text-3xl md:text-5xl lg:text-6xl 3xl:text-7xl tv:text-8xl font-bold text-background-50 leading-[1.15] mb-4 md:mb-6 animate-fade-in-up animate-fade-in-up-delay-2 hero-text-shadow">
            Explore The World With{' '}
            <span className="text-primary-400 hero-text-shadow">Lucky</span>{' '}
            <span className="text-accent-400 hero-text-shadow">Holidays</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-xl text-background-50/90 font-body font-light mb-3 md:mb-4 animate-fade-in-up animate-fade-in-up-delay-3 hero-text-shadow">
            International &amp; Domestic Holiday Experiences Crafted Just For You.
          </p>

          {/* Description */}
          <p className="text-sm md:text-base text-background-50/85 leading-relaxed max-w-2xl tv:max-w-3xl mb-6 md:mb-8 animate-fade-in-up animate-fade-in-up-delay-4 hero-text-shadow">
            We create personalized and unforgettable travel experiences across the globe. From family vacations and group tours to corporate travel and luxury holidays, Lucky Holidays offers end-to-end travel solutions tailored to every journey.
          </p>

          {/* Buttons - stacked full-width on mobile, row on sm+ */}
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 animate-fade-in-up animate-fade-in-up-delay-4">
            <a
              href="#contact"
              className="btn-ripple w-full sm:w-auto px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 hover-glow-primary transition-all duration-300 whitespace-nowrap text-center cursor-pointer shadow-lg shadow-black/20 inline-flex items-center justify-center"
            >
              Plan Your Journey
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#destinations"
              className="btn-ripple w-full sm:w-auto px-6 py-3 md:px-8 md:py-3.5 bg-foreground-950/30 backdrop-blur-md text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-foreground-950/45 border border-background-50/25 transition-all duration-300 whitespace-nowrap text-center cursor-pointer shadow-lg shadow-black/15 inline-flex items-center justify-center"
            >
              Explore Destinations
              <i className="ri-compass-3-line ml-2"></i>
            </a>
          </div>

          {/* Scroll indicator - in flow on mobile, absolute on desktop */}
          <div className="flex md:hidden justify-center mt-10 animate-float">
            <a href="#services" className="flex flex-col items-center gap-1 text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
              <span className="text-[10px] tracking-widest uppercase">Scroll</span>
              <i className="ri-arrow-down-line text-base animate-icon-bounce"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator - absolute on desktop */}
      <div className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float">
        <a href="#services" className="flex flex-col items-center gap-1.5 text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
          <span className="text-[9px] tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line text-lg animate-icon-bounce"></i>
        </a>
      </div>
    </section>
  );
}